import React from 'react'
import { useParams } from 'react-router-dom'
import OverviewTab from './OverviewTab'

const OverviewTabWrapper = (props) => {
    const params = useParams()
    return <OverviewTab {...props} params={params} />
}

export default OverviewTabWrapper
